<template>
  <div>
    <div v-if="cardData" class="w-full">
      <CardInfo :cardData="cardData" class="mb-4" />
      <v-row no-gutters class="buton-row">
        <v-col cols="12" sm="6" class="button-col">
          <v-btn
            :loading="processingRequest"
            @click="$emit('register')"
            block
            color="primary"
            elevation="2"
            class="d-flex align-center justify-center py-3"
            :disabled="processingRequest"
          >
            <v-icon class="mr-2">mdi-credit-card-outline</v-icon>
            <span>{{ registerButtonTitle }}</span>
          </v-btn>
        </v-col>
        <!-- <v-col cols="12" sm="6" class="button-col">
          <v-btn
            color="black"
            outlined
            block
            elevation="0"
            class="d-flex align-center justify-center py-3"
            @click="$emit('cancel')"
          >
            <v-icon class="mr-2">mdi-close-circle-outline</v-icon>
            <span>{{ $t('modules.portalalumno.payments.cardRegistration.view.cancelSubscriptionButton') }}</span>
          </v-btn>
        </v-col> -->
      </v-row>
    </div>
    <v-card
      v-else
      class="pa-2 pa-md-8 mx-auto my-8 rounded-xl elevation-1 w-100"
      color="grey lighten-4"
      tile
    >
      <div class="d-flex flex-column align-center justify-center text-center w-100">
        <v-avatar size="72" class="mb-4" color="blue lighten-5">
          <v-icon color="primary" size="40">mdi-credit-card-plus-outline</v-icon>
        </v-avatar>
        <div class="font-weight-bold headline mb-2">{{ $t('modules.portalalumno.payments.cardRegistration.view.cardRegistrationTitle') }}</div>
        <div class="subtitle-1 mb-6 description-width">
          <slot name="register-description">
            {{ $t('modules.portalalumno.payments.cardRegistration.view.cardRegistrationDescription') }}
          </slot>
        </div>
        <div class="d-flex flex-row align-center justify-center mb-6">
          <div class="d-flex align-center mr-3">
            <v-icon left small color="success" class="mr-1">mdi-shield-check</v-icon>
            {{ $t('modules.portalalumno.payments.cardRegistration.view.bankEncryption') }}
          </div>
          <div class="d-flex align-center">
            <v-icon left small color="success" class="mr-1">mdi-certificate-outline</v-icon>
            {{ $t('modules.portalalumno.payments.cardRegistration.view.pciDssCertified') }}
          </div>
        </div>
        <v-btn
          :loading="processingRequest"
          @click="$emit('register')"
          color="primary"
          class="rounded-lg px-10 py-3 font-weight-bold mx-auto"
          :class="{'d-none d-md-flex': false}"
          :style="$vuetify.breakpoint.smAndDown ? 'min-width: 180px;' : 'min-width: 260px; max-width: 320px; width: 320px;'"
          :disabled="processingRequest"
          elevation="2"
        >
          <v-icon left>mdi-credit-card-outline</v-icon>
          <span>{{ registerButtonTitle }}</span>
        </v-btn>
        <div class="caption text-center mt-4 grey--text">
          {{ $t('modules.portalalumno.payments.cardRegistration.view.poweredByFlywire') }}
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import CardInfo from './CardInfo.vue';
export default {
  name: 'CardRegistrationActions',
  components: { CardInfo },
  props: {
    cardData: Object,
    loading: Boolean,
    processingRequest: Boolean,
    registerButtonTitle: {
      type: String,
      default: 'Registrar tarjeta'
    }
  }
}
</script>

<style scoped>
.button-row {
  gap: 10px;
}
.button-col {
  padding: 0 5px;
}
.description-width {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 960px) {
  .description-width {
    width: 70%;
  }
}
@media (max-width: 599px) {
  .button-row {
    gap: 10px;
    flex-direction: column;
  }
  .button-col {
    padding: 5px 0;
  }
}
@media (min-width: 600px) {
  .button-col:first-child {
    padding-right: 5px;
  }
  .button-col:last-child {
    padding-left: 5px;
  }
}
</style> 